/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PersonNoteResource } from '../models/PersonNoteResource';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class PeopleNotesService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * List person notes
     * Get all notes for a person
     * @returns any Success
     * @throws ApiError
     */
    public getPeopleNotes({
        person,
    }: {
        /**
         * The person ID
         */
        person: number,
    }): CancelablePromise<{
        data?: Array<PersonNoteResource>;
    }> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/people/{person}/notes',
            path: {
                'person': person,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Person not found`,
            },
        });
    }

    /**
     * Create person note
     * Create a new note for a person
     * @returns any Note created successfully
     * @throws ApiError
     */
    public createPersonNote({
        person,
        requestBody,
    }: {
        /**
         * The person ID
         */
        person: number,
        requestBody: {
            /**
             * The note content
             */
            notes: string;
            /**
             * Whether the note is private
             */
            is_private?: boolean;
        },
    }): CancelablePromise<{
        data?: PersonNoteResource;
    }> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/people/{person}/notes',
            path: {
                'person': person,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Person not found`,
            },
        });
    }

    /**
     * Get person note
     * Get a specific note for a person
     * @returns any Success
     * @throws ApiError
     */
    public getPersonNote({
        person,
        note,
    }: {
        /**
         * The person ID
         */
        person: number,
        /**
         * The note ID
         */
        note: number,
    }): CancelablePromise<{
        data?: PersonNoteResource;
    }> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/people/{person}/notes/{note}',
            path: {
                'person': person,
                'note': note,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Note not found`,
            },
        });
    }

    /**
     * Delete person note
     * Delete a specific note for a person
     * @returns void
     * @throws ApiError
     */
    public deletePersonNote({
        person,
        note,
    }: {
        /**
         * The person ID
         */
        person: number,
        /**
         * The note ID
         */
        note: number,
    }): CancelablePromise<void> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/people/{person}/notes/{note}',
            path: {
                'person': person,
                'note': note,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Note not found`,
            },
        });
    }

    /**
     * Update person note
     * Update a specific note for a person
     * @returns any Note updated successfully
     * @throws ApiError
     */
    public updatePersonNote({
        person,
        note,
        requestBody,
    }: {
        /**
         * The person ID
         */
        person: number,
        /**
         * The note ID
         */
        note: number,
        requestBody: {
            /**
             * The note content
             */
            notes?: string;
            /**
             * Whether the note is private
             */
            is_private?: boolean;
        },
    }): CancelablePromise<{
        data?: PersonNoteResource;
    }> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/people/{person}/notes/{note}',
            path: {
                'person': person,
                'note': note,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Note not found`,
            },
        });
    }

}
